<template>
  <div class="full-height">
    <transition :name="transitionName">
      <keep-alive :include="$route.meta.include">
        <!-- 这里是会被缓存的视图组件A -->
        <router-view />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import themeCssTmpl from '@/common/assets/styles/theme'
import { localget, localset ,localremove} from 'Utils/storage.js'
import { judgeClient, is_weixn, getSysType } from 'CommonUtils/plus'
import { getClientid, push } from 'CommonUtils/push'
import hashchange from '@/business/mixins/hashchange';

function clearDataCache(){
  localremove('geo_10901_zh-CN')
  localremove('geo_10902_zh-CN')
  localremove('geo_10903_zh-CN')
  localremove('geo_10904_zh-CN')
}

export default {
  mixins: [hashchange],
  created() {
    this.pageSet()

    // vuex中的state与session同步
    let state = localget('VUEX_STATE')
    // 安卓微信浮窗切换会清空session缓存，默认往local也放了一份store数据，如果session取不到试着去local取
    if (!state && judgeClient() === 'Android' && is_weixn() && !window.wx_min) {
      state = localget('VUEX_STATE')
      let token = localget('access_token')
      localset('access_token', token)
    }

    // 微信JSSDK签名权限
    if (is_weixn()) {
      this.$api['common/getSdkQx']({
        url: window.location.href.split('#')[0]
      }).then(res => {
        var cache = res.data || {}
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: cache.appId, // 必填，公众号的唯一标识
          timestamp: cache.timestamp, // 必填，生成签名的时间戳
          nonceStr: cache.nonceStr, // 必填，生成签名的随机串
          signature: cache.signature,// 必填，签名
          jsApiList: ['openLocation'] // 必填，需要使用的JS接口列表
        })
      }).catch(res => {
        // console.log('configError', res)
      })
    }

    if (state) {
      this.$store.replaceState(Object.assign(this.$store.state, state))
    }

    var lastLongin=localget('lastLongin')||''
    if(lastLongin){
      if((new Date().getTime()-lastLongin)/1000/60/60>48){
        clearDataCache()
        localset('lastLongin',new Date().getTime())
      }
    }else{
      localset('lastLongin',new Date().getTime())
    }

  },
  computed: {
    ...mapGetters({
      transitionName:'transitionName',
      isPush:'isPush',
      userInfo:'userInfo',
    })
  },
  mounted(){
    var self=this
    var plusReady = function (callback) {
      if (window.plus) {
        callback()
        onPlusReady()
        getClientid()
        self.isPush?push():''//推送
      } else {
        document.addEventListener('plusready', callback)
        document.addEventListener('plusready', onPlusReady, false)
        document.addEventListener('plusready', getClientid)
        self.isPush?document.addEventListener('plusready', push):''
        console.log('推送1',self.isPush)
      }
    }

    plusReady(function () {
      var firstBack = 0
      var handleBack = function () {
        var currentWebview = plus.webview.currentWebview()
        var topWebview = plus.webview.getTopWebview()
        var now = Date.now || function () {
          return new Date().getTime()
        }
        currentWebview.canBack(function (evt) {
          /**
                     * 有可后退的历史记录，则后退。
                     * 否则，关闭当前窗口。
                     * 如果当前窗口是入口页，那么执行退出的逻辑。
                     */
          if (currentWebview.id === plus.runtime.appid) {
            // 模式不同，需要取的值也不一样，这里仅做示例，非真实场景。
            var path = location.path
            var hash = location.hash

            if (hash === '/'||hash === '#/home' || hash === '#/login') {
              if (!firstBack) {
                firstBack = now()
                plus.nativeUI.toast('再按一次退出应用')

                setTimeout(function () {
                  firstBack = 0
                }, 1000)
              } else if (now() - firstBack < 1000) {
                // 入口页了，执行退出。
                plus.runtime.quit()
              }
            } else {
              // 根据实际需求选择相应的方法
              //this.$router.go(-1)
              history.back()
            }
          } else {
            if (evt.canBack) {
              history.back()
            } else {
              currentWebview.close('auto')
            }
          }
        })
      }
      //监听手机返回键
      plus.key.addEventListener('backbutton', handleBack)
    })

    function onPlusReady(){
      document.addEventListener('foreground', onAppForeground, false)
    }
    function onAppForeground(e){
      // plus.nativeUI.alert(JSON.stringify(e), function(){
      console.log(e)
      console.log('激活应用到前台来源 User pressed!')
      // }, '激活应用到前台来源', 'OK')
      //e.active表明激活应用到前台来源
      // 可取值："default"-默认激活方式，通常表示通过应用列表启动激活，或者关闭前一个应用后自动激活等；
      //         "stream"-通过流应用api（plus.stream.open）激活；
      //         "scheme"-通过urlscheme方式触发激活；
      //         "push"-通过点击系统通知方式触发激活；
      //         "barcode"-通过二维码扫描激活；
      //         "myapp"-通过应用收藏列表（[流应用]独立App中"我的"列表）触发激活
      var activeType = e.active	// 获取激活到前台来源
    }
  },
  methods: {
    // 获取页面风格设置
    async pageSet() {
      try {
        let { data = {} } = await this.$api['common/etPageSetList']()

        if (data.by2) data.by2 = data.by2.replace(/(\r\n|\n|\r)/gm, '<br />')
        if (data.pageName) document.querySelector('title').innerText = data.pageName
        if (data.logoUrl) document.querySelector('#etBrowserLogo').href = data.logoUrl

        this.$store.commit('SET_LOGINCONFIG', data)

        let appTheme = {
          'tkQuery-banner-url': '',//机票查询页背景图
          'trQuery-banner-url': '',//火车票查询页背景图
          'htQuery-banner-url': '',//酒店查询页背景图
          'carQuery-banner-url': '',//用车查询页背景图
          'home-banner-url': '',//首页背景图
          'color-text-main': '',//字体颜色 主题色
          'bg-main-color': '',//主背景色
          'bg-lightYellow': '',//浅背景色
          'bg-lightColor': '',// 更浅背景色
          'linear-main1': '', // 按钮颜色 渐变色 主要用于 下单查询按钮 一般为红色
          'linear-main2': '', // 按钮颜色 渐变色 主题色 主要用于 登录退出 其它按钮 左到右 颜色渐深
          'linear-main3': '',// 按钮颜色  纯色  主题色  备用
          'linear-main4': '',// 按钮颜色  渐变色 主题色 可用于 登录退出 审批页面 右到左 颜色渐深 备用
          ...JSON.parse(data.by1 || '{}')
        }

        if (data.tSysStyle && data.tSysStyle !== '1') {
          let themeBean = data.themeBean
          if (themeBean) {
            appTheme = {
              ...appTheme,
              'color-text-main': themeBean.mainColor,
              'bg-main-color': themeBean.backColor,
              'bg-lightYellow': themeBean.lightBackColor,
              'bg-lightColor':themeBean.lightBackColor1,
              'linear-main1': themeBean.linearMain1,
              'linear-main2': themeBean.linearMain2,
              'linear-main3': themeBean.linearMain3,
              'linear-main4': themeBean.linearMain4,
            }
          }
        } else { // 默认主题
          if (data.domainName && data.domainName.indexOf('qhtxtrip') > -1) { // 智通土豪金
            appTheme = {
              ...appTheme,
              'color-text-main': '#baa179',
              'bg-main-color': '#c6a685',
              'bg-lightYellow': '#fff5e4',
              'bg-lightColor':'#fff5e4',
              'linear-main1': '-webkit-linear-gradient(left, #ff7b46 0%, #ff5346 100%)',
              'linear-main2': '-webkit-linear-gradient(right, #c59f60 0%, #eacd95 100%)',
              'linear-main3': '-webkit-linear-gradient(bottom, #eef2f7 50%, #baa179 70%)',
              'linear-main4': '-webkit-linear-gradient(left, #c59f60 0%, #eacd95 100%)',
            }
          }
          // 供应商的默认主题是蓝色
        }

        this.createCss(appTheme) // tSysStyle 默认风格 1标准默认风格，2智通天行定制
      } catch (err) {
        throw err
      }
    },
    async createCss (appTheme) {
      if (appTheme == '{}') {
        return
      }
      try {
        let cssText = themeCssTmpl
          .replace(/@color-text-main/g, appTheme['color-text-main'].trim())
          .replace(/@bg-main-color/g, appTheme['bg-main-color'].trim())
          .replace(/@bg-lightYellow/g, appTheme['bg-lightYellow'].trim())
          .replace(/@bg-lightColor/g, appTheme['bg-lightColor']?appTheme['bg-lightColor'].trim():'')
          .replace(/@linear-main1/g, appTheme['linear-main1'].trim())
          .replace(/@linear-main2/g, appTheme['linear-main2'].trim())
          .replace(/@linear-main3/g, appTheme['linear-main3'].trim())
          .replace(/@linear-main4/g, appTheme['linear-main4']?appTheme['linear-main4'].trim():'')
          .replace(/@home-banner-url/g, appTheme['home-banner-url'].trim() && `url(${appTheme['home-banner-url'].trim()})`)
          .replace(/@tkQuery-banner-url/g, appTheme['tkQuery-banner-url'].trim() && `url(${appTheme['tkQuery-banner-url'].trim()})`)
          .replace(/@trQuery-banner-url/g, appTheme['trQuery-banner-url'].trim() && `url(${appTheme['trQuery-banner-url'].trim()})`)
          .replace(/@htQuery-banner-url/g, appTheme['htQuery-banner-url'].trim() && `url(${appTheme['htQuery-banner-url'].trim()})`)
          .replace(/@carQuery-banner-url/g, appTheme['carQuery-banner-url'].trim() && `url(${appTheme['carQuery-banner-url'].trim()})`)
        this.setThemeColor(cssText)
      } catch (error) {
        console.error('主题色创建错误', error)
      }
    },
    setThemeColor (cssText) {
      let head = document.head || document.getElementsByTagName('head')[0]
      let style = document.createElement('style')
      style.setAttribute('type', 'text/css')
      style.innerHTML = cssText
      head.appendChild(style)
    }
  },
  watch: {
    '$store.state': {
      handler: function (val) {
        // sessionset('VUEX_STATE', val)
        localset('VUEX_STATE', val)
      },
      deep: true
    }
  }
}
</script>

<style lang="less">
@import "assets/styles/base.less";
@import "assets/styles/transition.less";
// 隐藏 ios 滚动条
::-webkit-scrollbar {
  display: none;
  width: 0 !important;
  height: 0 !important;
  -webkit-appearance: none;
  background: transparent;
}
</style>
